import React, { useState, useEffect } from 'react';
import { FaShareAlt, FaEnvelope } from 'react-icons/fa';
import API_URL from '../api/APIUrl';
import { Link } from 'react-router-dom';


const StudentSearch = () => {
  const [filters, setFilters] = useState({
    state: '',
    city: '',
    zipcode: '',
    educationCategory: '',
    religion: '',
    caste: '',
    subCaste: ''
  });

  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Dropdown Data
  const [allStates, setAllStates] = useState([]);
  const [allCities, setAllCities] = useState([]);
  const [allReligions, setAllReligions] = useState([]);
  const [allCastes, setAllCastes] = useState([]);
  const [allSubCastes, setAllSubCastes] = useState([]);

  const [showPopup, setShowPopup] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState(null);

  const handleContactAdmin = (student) => {
    setSelectedStudent(student);
    setShowPopup(true);
  };
  

  useEffect(() => {
    const fetchAllStates = async () => {
      const response = await fetch(API_URL.GET_ALL_STATES);
      const json = await response.json();
      setAllStates(response.ok ? json : []);
    };
    fetchAllStates();
  }, []);

  useEffect(() => {
    const fetchAllCities = async () => {
      if (filters.state) {
        const response = await fetch(API_URL.GET_ALL_CITIES + filters.state);
        const json = await response.json();
        setAllCities(response.ok ? json : []);
      } else {
        setAllCities([]);
      }
    };
    setFilters((prev) => ({ ...prev, city: '' }));
    fetchAllCities();
  }, [filters.state]);

  useEffect(() => {
    const fetchAllReligions = async () => {
      const response = await fetch(API_URL.GET_ALL_RELIGION);
      const json = await response.json();
      setAllReligions(response.ok ? json : []);
    };
    fetchAllReligions();
  }, []);

  useEffect(() => {
    const fetchAllCastes = async () => {
      if (filters.religion) {
        const response = await fetch(API_URL.GET_CASTE_BY_RELIGION + filters.religion);
        const json = await response.json();
        setAllCastes(response.ok ? json : []);
      } else {
        setAllCastes([]);
      }
    };
    setFilters((prev) => ({ ...prev, caste: '', subCaste: '' }));
    fetchAllCastes();
  }, [filters.religion]);

  useEffect(() => {
    const fetchAllSubCastes = async () => {
      if (filters.caste) {
        const response = await fetch(API_URL.GET_SUBCASTE_BY_CASTE + filters.caste);
        const json = await response.json();
        setAllSubCastes(response.ok ? json : []);
      } else {
        setAllSubCastes([]);
      }
    };
    setFilters((prev) => ({ ...prev, subCaste: '' }));
    fetchAllSubCastes();
  }, [filters.caste]);

  const fetchStudents = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API_URL.SEARCH_STUDENT}?state=${filters.state}&city=${filters.city}&zipcode=${filters.zipcode}&educationCategory=${filters.educationCategory}&religion=${filters.religion}&caste=${filters.caste}&subCaste=${filters.subCaste}`);
      const data = await response.json();
      setStudents(data.success && Array.isArray(data.students) ? data.students : []);
      console.log(data.students);
      setError(data.success ? null : 'No students found');
    } catch (err) {
      setError('Failed to fetch students');
      setStudents([]);
    }
    setLoading(false);
  };

  const handleFilterChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };


  const handleShare = (student) => {
    const balanceFees = calculateBalance(student.total_fees, student.arranged_amount);
    const formattedName = formatName(student.firstname, student.middlename, student.surname);
  
    const studentDetails = `Student: ${formattedName}
  State: ${student.state}
  City: ${student.city}
  Religion: ${student.religion}
  Caste: ${student.caste}
  Sub-Caste: ${student.subCaste}
  Education: ${student.education_category}
  Needs Help for: ${student.need_financial_help_for}
  Total Fees: ${student.total_fees}
  Arranged: ${student.arranged_amount}
  Balance Fees: ${balanceFees}`;
  
    navigator.share({ 
      text: studentDetails, 
      url: `${API_URL.GET_BASE}student/${student._id}` 
    });
  };

 /* const handleShare = async (student) => {
    const studentDetails = `Student: ${maskName(student.firstname, student.surname)}\nState: ${student.state}\nCity: ${student.city}\nEducation: ${student.education_category}\nNeeds Help for: ${student.need_financial_help_for}\nBalance Fees: ${student.balance_fees}`;
    const shareUrl = `http://localhost:3000/student/${student._id}`;
  
    try {
      if (navigator.share) {
        await navigator.share({
          text: studentDetails,
          url: shareUrl
        });
      } else {
        // Fallback to WhatsApp if `navigator.share` is not supported
        const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(studentDetails + '\n' + shareUrl)}`;
        window.open(whatsappUrl, '_blank');
      }
    } catch (error) {
      console.log('Share action was canceled or failed:', error.message);
    }
  };*/


  const formatName = (firstname, middlename = '', surname = '') => {
    const middleInitial = middlename ? middlename.charAt(0).toUpperCase() + '.' : '';
    const lastInitial = surname ? surname.charAt(0).toUpperCase() + '.' : '';
    return `${firstname} ${middleInitial} ${lastInitial}`.trim();
  };
  
  const calculateBalance = (total, arranged) => {
    const totalAmt = Number(total) || 0;
    const arrangedAmt = Number(arranged) || 0;
    return totalAmt - arrangedAmt;
  };

  return (
    <div className="container mt-4">
      <h2>Search for Students</h2>
      <div className="row mb-3">
        <div className="col-md-3">
          <select name="state" value={filters.state} onChange={handleFilterChange} className="form-control">
            <option value="">Select State</option>
            {allStates.map((state) => <option key={state._id} value={state._id}>{state.title}</option>)}
          </select>
        </div>
        <div className="col-md-3">
          <select name="city" value={filters.city} onChange={handleFilterChange} className="form-control" disabled={!filters.state}>
            <option value="">Select City</option>
            {allCities.map((city) => <option key={city._id} value={city._id}>{city.title}</option>)}
          </select>
        </div>
        <div className="col-md-3">
          <select name="religion" value={filters.religion} onChange={handleFilterChange} className="form-control">
            <option value="">Select Religion</option>
            {allReligions.map((religion) => <option key={religion._id} value={religion.title}>{religion.title}</option>)}
          </select>
        </div>
        <div className="col-md-3">
          <select name="caste" value={filters.caste} onChange={handleFilterChange} className="form-control" disabled={!filters.religion}>
            <option value="">Select Caste</option>
            {allCastes.map((caste) => <option key={caste._id} value={caste.title}>{caste.title}</option>)}
          </select>
        </div>
      </div>
      <div className="row mb-3">
        <div className="col-md-3">
          <select name="subCaste" value={filters.subCaste} onChange={handleFilterChange} className="form-control" disabled={!filters.caste}>
            <option value="">Select Sub-Caste</option>
            {allSubCastes.map((subCaste) => <option key={subCaste._id} value={subCaste.title}>{subCaste.title}</option>)}
          </select>
        </div>
        <div className="col-md-3">
          <select name="educationCategory" value={filters.educationCategory} onChange={handleFilterChange} className="form-control">
            <option value="">Select</option>
            <option value="Pre-Primary (LKG to UKG)">Pre-Primary (LKG to UKG)</option>
            <option value="Primary (1st to 4th)">Primary (1st to 4th)</option>
            <option value="High School (5th to 10th)">High School (5th to 10th)</option>
            <option value="Junior College (11th to 12th)">Junior College (11th to 12th)</option>
            <option value="Diploma Course">Diploma Course</option>
            <option value="Graduation">Graduation</option>
            <option value="Post Graduation">Post Graduation</option>
            <option value="Professional Course">Professional Course</option>
            <option value="Administrative Course">Administrative Course</option>
            <option value="Educational Equipment ">Educational Equipment</option>
          </select>
        </div>
        <div className="col-md-3">
          <button className="btn btn-primary" onClick={fetchStudents}>Search</button>
        </div>
      </div>
      {loading && <p>Loading...</p>}
      {error && <p className="text-danger">{error}</p>}
      {students.length === 0 && !loading && <p>No students found matching your filters.</p>}

      <div className="list-group">
        {students.map((student) => (
          <div key={student.firstname + student.surname} className="list-group-item d-flex justify-content-between align-items-center">
            <div>
              <h5>{formatName(student.firstname, student.middlename, student.surname)}</h5>
              <p>State: {student.state}, City: {student.city}</p>
              <p>Education: {student.education_category}</p>
              <p>Needs Help for: {student.need_financial_help_for}</p>
              <p>Total Fees: {student.total_fees}</p>
              <p>Arranged: {student.arranged_amount}</p>
              <p>Balance: {calculateBalance(student.total_fees, student.arranged_amount)}</p>
              <p>Religion: {student.religion}, Caste: {student.caste}, Sub-Caste: {student.subCaste}</p>
              <Link to={`/student/${student._id}`} className="btn btn-link">View Details</Link>
            </div>
            <div>
              <button className="btn btn-secondary mx-2" onClick={() => handleContactAdmin(student)}>
                <FaEnvelope /> Contact Admin
              </button>
              <button className="btn btn-info" onClick={() => handleShare(student)}>
                <FaShareAlt /> Share
              </button>
            </div>
          </div>
        ))}



            {showPopup && selectedStudent && (
              <div className="modal d-block" tabIndex="-1" role="dialog" style={{ background: 'rgba(0,0,0,0.5)' }}>
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Contact Admin</h5>
                      <button type="button" className="close" onClick={() => setShowPopup(false)}>
                        <span>&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      <p>You can contact the admin to help this student:</p>
                      <p><strong>Name:</strong> {formatName(selectedStudent.firstname, selectedStudent.middlename, selectedStudent.surname)}</p>
                      <p><strong>Email:</strong> <a href="mailto:admin@example.com">admin@example.com</a></p>
                    </div>
                    <div className="modal-footer">
                      <button type="button" className="btn btn-secondary" onClick={() => setShowPopup(false)}>Close</button>
                    </div>
                  </div>
                </div>
              </div>
            )}
      </div>
      </div>





  );
};

export default StudentSearch;
